<template>
  <div>
    <h3>ご回答ありがとうございます。<br>より良いサービス提供のために活用させていただきます。</h3>
    <BtnNomal BtnNomal="HOME" @click="home()" />
  </div>
</template>

<script>
import BtnNomal from "@/atoms/BtnNomal.vue";
export default {
  name: "ThanKs",
  components: { BtnNomal },
  methods: {
    home() {
      // setTimeout(() => {
      //   this.isLoading = false;
      // }, 500);
      this.$router.push("/").catch(() => { });
      // this.$router.push("/");
      // const url = 'https://www.star-system.jp/'
      // window.open(url, '_blank')
      // this.$router.push({ path: "/", force: true });
      // this.$router.go({ path: "/", force: true }).catch(() => {});
    },
  },
};
</script>

<style></style>